import React from 'react';

interface InvoiceDownloadProps {
  downloadUrl: string;
}

export const InvoiceDownload: React.FC<InvoiceDownloadProps> = ({ downloadUrl }) => (
  <a className="actions-opener" href={downloadUrl} title={t('label.download')}>
    <i className="icon-download" />
  </a>
);
